import { render } from "./lesson-nav.vue?vue&type=template&id=fd80b8ce&ts=true"
import script from "./lesson-nav.ts?vue&type=script&lang=ts&external"
export * from "./lesson-nav.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__